import { MouseEvent } from 'react';
import { ContactInfo } from './ContactUs';

export interface NavMenuItem {
  navId: string;
  ariaLabel?: string;
  label: string;
  logo?: string;
  invertedLogo?: string;
  href?: string;
  target?: string;
  isMobileOnly?: boolean;
  subMenuList?: NavMenuItem[];
}

export interface NavMenuLang {
  navId: string;
  ariaLabel?: string;
  label: string;
  className?: string;
  href: string;
  hrefLang: string;
  onLanguageToggle?: (e: MouseEvent) => void;
  isVisible?: boolean;
}

export interface Branding {
  logo?: string;
  href?: string;
  invertedLogo?: string;
  label?: string;
  ariaLabel?: string;
}

export interface Profile {
  signInLink: string;
  signInLabel: string;
  authProfile: NavMenuItem;
}

export interface NavMenu {
  logo?: Branding;
  branding: Branding;
  mobileMenuItem?: NavMenuItem;
  menuList?: NavMenuItem[];
  toggleOpen: NavMenuItem;
  toggleClose: NavMenuItem;
  isCollapsed?:boolean;
  isB2C?: boolean;
  referenceId?: boolean;
  onSelect?: (navId: string, e: MouseEvent) => void;
  onLanguageToggle?: (e: MouseEvent) => void;
  defaultSelected?: string;
  languageToggleLabel: string;
  languageToggleAriaLabel?: string;
  languageToggleLink?: string;
  profile: Profile;
  isAuthenticated?: boolean;
  staticSubMenuNavId?: string;
  languageInfo?: NavMenuLang;
  contactUs?: NavMenuItem;
  contactInfo?: ContactInfo;
  contactBackButtonLabel?: string;
  userName?: string;
  userType?: string;
  organizationCategory?: string;
  claims?: string[];
  organizationCode?: string;
  showOrgSearch?: boolean;
  organizationDropDownList?: {
    label: string;
    value: string;
  }[];
  searchOrganizations?: (str: string) => [];
  organizationSelectionChange?: (val: string) => void;
  organizationText?: string;
  featureFlags?: Record<string, any>[];
}

export interface NavContextProps {
  activeKey: string;
  setActiveKey: (val: string) => void;
  activeParents: string[];
  mobileToggle: boolean;
  setMobileToggle: (val: boolean) => void;
  clickedOutside: boolean;
  setClickedOutside: (val: boolean) => void;
  isMobile: boolean;
  onSelect?: (navId: string, e: MouseEvent) => void;
  getParent: (navId: string) => string[];
  dropOpen: string;
  dropSubMenuOpen: string;
  setDropOpen: (val: string) => void;
  setDropSubMenuOpen: (val: string) => void;
  showContact?: boolean;
  setShowContact?: (val: boolean) => void;
}

export interface ParentMap {
  navId: string;
  parents?: string[];
}

export enum NavMenuVariant {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}

export interface ElementProps {
  src: string;
  label: string;
  showDrop?: boolean;
  dropExpanded?: boolean;
  isMobile?: boolean;
}

export interface AnchorElementProps {
  href: string;
  className: string;
  onClick: (e: MouseEvent) => void;
  navId: string;
  ariaLabel: string;
  label: string;
  isMobile?: boolean;
  logo: string;
}

export interface ButtonElementProps {
  className?: string;
  onClick: (e: MouseEvent) => void;
  navId?: string;
  ariaLabel?: string;
  label?: string;
  isMobile?: boolean;
  dropOpen: boolean;
  showDrop: boolean;
  logo: string;
}

export interface NavMenuElementProps extends NavMenuItem {
  onClick: (e: MouseEvent) => void;
  className?: string;
  isMobile?: boolean;
  dropOpen?: boolean;
  showDrop?: boolean;
}

export interface NavElementProps extends NavMenuItem {
  variant?: NavMenuVariant;
  className?: string;
  disableDrop?: boolean;
}

export interface MenuListProps {
  items: NavElementProps[];
  className?: string;
  id?: string;
  isAuthenticated: boolean;
  staticSubMenuNavId?: string;
  languageToggleLabel: string;
  languageToggleAriaLabel?: string;
  languageToggleLink?: string;
  profile: Profile;
  contactUs?: NavMenuItem;
  contactInfo?: ContactInfo;
  contactBackButtonLabel?: string;
  userName?: string;
  contextPath?: string;
  onLanguageToggle?: (e: MouseEvent) => void;
}

export interface MenuToggleProps {
  toggleOpen: NavMenuItem;
  toggleClose: NavMenuItem;
  ariaControls: string;
}

export const KEY_CODE = {
  ENTER: 13,
  SPACE: 32
};
